/**
 * Hier wird das Submenu eingebunden
 */

import React from 'react'
import { Container, Grid } from '@mui/material'

import SettingsUserData from './subScreens/SettingsUserData'
import { useRouteMatch } from 'react-router'
import { Redirect, Route, Switch } from 'react-router-dom'
import SettingsConnect from './subScreens/SettingsConnect'

export enum SettingsSubScreen {
  userData = 'userData',
  connect = 'connect',
}

type Props = {
  user?: any
}

const SettingsApp: React.FC<Props> = (props) => {
  const { path } = useRouteMatch()

  return (
    <Container maxWidth="lg">
      <Grid container columnSpacing={2} sx={{ px: 2, pb: 6 }}>
        <Grid
          xs={12}
          item
          container
          direction="row"
        >
          <Grid container item xs={12}>
            <Switch>
              <Redirect exact from={`${path}`} to={`${path}/userData`}/>
              <Route path={`${path}/userData`}>
                <SettingsUserData user={props.user}/>
              </Route>
              {props.user?.role === 'USER' &&
                <Route path={`${path}/connect`}>
                  <SettingsConnect/>
                </Route>}
            </Switch>
          </Grid>
        </Grid>
      </Grid>
    </Container>
  )
}

export default SettingsApp
